import { Button } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useTranslation from '../../../services/i18n/core/useTranslation';
import NotificationActionCreator from '../../../services/Notifications/actions/NotificationActionCreator';
import { applyPwaDocumentBrand, registerServiceWorker } from '../serviceWorker/registerServiceWorker';
import PwaInstallPrompt from './PwaInstallPrompt';

/**
 * Mounts PWA runtime concerns once at app root:
 * - brand meta from Config (name / theme color)
 * - service worker registration (production) + brand sync for push
 * - mobile install UX
 */
export function PwaBootstrap() {
    const dispatch = useDispatch();
    const { PWA_UPDATE_AVAILABLE_TEXT, PWA_UPDATE_AVAILABLE_BUTTON } = useTranslation();

    useEffect(() => {
        applyPwaDocumentBrand();
        void registerServiceWorker({
            // A new version already took over in the background; the open
            // session is still running the old bundle until it reloads. Show
            // a persistent prompt instead of forcing a reload, so an active
            // swipe or a message being typed is never interrupted.
            onUpdateAvailable: () => {
                dispatch(
                    NotificationActionCreator.enqueueSnackbar({
                        key: 'pwa-update-available',
                        message: PWA_UPDATE_AVAILABLE_TEXT,
                        options: {
                            variant: 'info',
                            persist: true,
                            action: () => (
                                <Button color="inherit" size="small" onClick={() => window.location.reload()}>
                                    {PWA_UPDATE_AVAILABLE_BUTTON}
                                </Button>
                            ),
                        },
                    })
                );
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <PwaInstallPrompt />;
}

export default PwaBootstrap;
